module.exports = __webpack_public_path__ + "static/media/link-outlined.7b3c1f90.svg";